import React, { useState, useRef } from "react";
import { createCompany } from "../../../services/CompanyService";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import ReactInputMask from "react-input-mask";
import removerSpecialChars from "../../../util/StringUtils";

export const EmpresaForm = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const inputFantasyName = useRef("");
  const inputRepresentantName = useRef("");
  const inputRepresentantEmail = useRef("");
  const inputWhatsAppNumber = useRef("");
  const inputDocumentNumber = useRef("");

  const toggle = () => setIsOpen(!isOpen);

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    const data = {
      fantasyName: inputFantasyName.current.value,
      corporateName: inputFantasyName.current.value,
      representantName: inputRepresentantName.current.value,
      representantEmail: inputRepresentantEmail.current.value,
      whatsAppNumber: "55" + removerSpecialChars(inputWhatsAppNumber.current.value),
      documentNumber: removerSpecialChars(inputDocumentNumber.current.value),
      address: "",
      representantDocumentNumber: "",
      representantPhoneNumber: "55" + removerSpecialChars(inputWhatsAppNumber.current.value),
    };

    createCompany(data)
      .then((response) => {
        toast.success("Cadastro realizado e dados de acesso enviado ao cliente.");
        if (props.listCompanies) props.listCompanies(false);
        setIsOpen(false);
      })
      .catch((error) => {
        const msg = error.response?.data?.message || error.response?.data || "Erro ao criar empresa";
        const finalMsg = typeof msg === 'object' ? "Não foi possivel criar cadastro da Empresa" : msg;
        toast.error(finalMsg);
      })
      .finally(() => setLoading(false));
  }

  return (
    <div>
      {/* Botão de Trigger Premium */}
      <button
        onClick={() => setIsOpen(true)}
        type="button"
        className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center shadow"
        style={{ width: '54px', height: '54px', minWidth: '54px' }}
        title="Cadastrar Novo Cliente">
        <i className="fa fa-plus fs-5"></i>

      </button>

      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        backdrop="static"
        size="lg"
        centered
      >
        {/* Cabeçalho no Padrão de Configurações: Sem borda e Título em Preto */}
        <ModalHeader toggle={toggle} className="border-0 pb-0 pt-4 px-4">
          <h5 className="fw-bold text-dark mb-0">Novo Cliente</h5>
          <p className="text-muted small mb-0 mt-1">Cadastre uma nova empresa e envie as credenciais de acesso</p>
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="px-4 pt-3 pb-4">

            {/* SEÇÃO 1: DADOS DA EMPRESA (CARD LIGHT) */}
            <div className="bg-light p-3 rounded-4 border mb-4">
              <div className="d-flex align-items-center mb-3 text-primary">
                <i className="fas fa-store me-2"></i>
                <span className="fw-bold text-muted small text-uppercase" style={{ fontSize: '0.72rem' }}>
                  Identificação da Loja
                </span>
              </div>

              <div className="row g-3">
                <div className="col-lg-7">
                  <label className="form-label small fw-bold text-dark mb-2">Nome da Loja</label>
                  <input
                    ref={inputFantasyName}
                    type="text"
                    placeholder="Ex: Alcon Auto Lava Jato"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    required
                  />
                </div>

                <div className="col-lg-5">
                  <label className="form-label small fw-bold text-dark mb-2">CNPJ / CPF da Loja</label>
                  <input
                    ref={inputDocumentNumber}
                    type="text"
                    placeholder="Apenas números"
                    minLength={11}
                    maxLength={14}
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    title="Informe um CPF ou CNPJ válido"
                    required
                  />
                </div>
              </div>
            </div>

            {/* SEÇÃO 2: RESPONSÁVEL & ACESSO (CARD WHITE COM SOMBRA) */}
            <div className="bg-white p-3 rounded-4 border shadow-sm">
              <div className="d-flex align-items-center mb-3 text-primary">
                <i className="fas fa-user-shield me-2"></i>
                <span className="fw-bold text-muted small text-uppercase" style={{ fontSize: '0.72rem' }}>
                  Dados do Responsável & Acesso
                </span>
              </div>

              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label small fw-bold text-dark mb-2">Nome Completo do Dono</label>
                  <input
                    ref={inputRepresentantName}
                    type="text"
                    placeholder="Ex: João da Silva"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    required
                  />
                </div>

                <div className="col-lg-7">
                  <label className="form-label small fw-bold text-dark mb-2">E-mail de Acesso</label>
                  <input
                    ref={inputRepresentantEmail}
                    type="email"
                    placeholder="exemplo@alcon.com"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    required
                  />
                </div>

                <div className="col-lg-5">
                  <label className="form-label small fw-bold text-dark mb-2">WhatsApp</label>
                  <ReactInputMask
                    ref={inputWhatsAppNumber}
                    mask="(99) 99999-9999"
                    placeholder="(00) 00000-0000"
                    className="form-control form-control-lg fs-6 rounded-3 border-2 fw-bold text-primary"
                    required
                  />
                </div>
              </div>
            </div>

          </ModalBody>

          {/* Rodapé Alinhado ao Padrão de Configurações */}
          <ModalFooter className="border-0 pt-2 px-4 pb-4">
            {!loading ? (
              <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end">
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  className="btn btn-outline-secondary btn-lg fw-bold rounded-3 px-4 order-1 order-sm-0"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm px-4"
                  style={{ minWidth: '180px' }}
                >
                  Cadastrar
                </button>
              </div>
            ) : (
              <div className="w-100 text-center py-2">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
              </div>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default EmpresaForm;